import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState, useRef } from "react";
import { toast } from "react-toastify";
import  DataMigrationConfig  from "../util/dataMigrationConfig"
import { GETMIGRATIONDEFAULTOBJECT_REQ, GETMIGRATIONOBJECTVALIDATE_REQ,GETMIGRATIONDETAILS_REQ, GETMIGRATIONSTART_REQ, GETMIGRATIONSTATUSLIST_REQ } from "../../../../actions";
import { Popup } from "../../../../../src/components/pop-up";
import * as actions from "../../../../../src/actions/index";

const formatConfigLabel = (value) => (value || '').replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());

const groupDependencyList = (list) => {
  const grouped = new Map();
  (list || []).forEach((item) => {
    const key = `${item.config_module}::${item.config_name}`;
    if (!grouped.has(key)) {
      grouped.set(key, {
        name: formatConfigLabel(item.config_name),
        category: formatConfigLabel(item.config_module),
        neededBy: [],
      });
    }
    grouped.get(key).neededBy.push({
      parent: formatConfigLabel(item.needed_config_module),
      child: formatConfigLabel(item.needed_config_name),
    });
  });
  return Array.from(grouped.values());
};

export default function ModuleSelected({ setStep, formik, setCurrentMigID, isReadOnlyView, currentMigID, setselectedConfigFields }) {

  const migrationDefaultObject = useSelector((state) => state?.migration?.migration_default_object);
  const validationResult = useSelector((state) => state?.migration?.migration_validation_result);
  const migrationStartResult = useSelector((state) => state?.migration?.migration_start_result);
  const migrationStatusResult = useSelector((state) => state?.migration?.migration_status_list);
  const migrationDetails = useSelector((state) => state?.migration?.details);
  
  const urlParams = useRef({});
  const dispatch = useDispatch();
  const [openModal, setOpenModal] = useState();
  const [selectedDataConfigFields, setselectedDataConfigFields] = useState([])
  const [dependencyList, setDependencyList] = useState([])
  const [isValidationMaded, setisValidationMaded] = useState(false)
  const [migrationObjectArray, setMigrationDefaultObject] = useState(migrationDefaultObject.data)
  const [currentTabIndex, setcurrentTabIndex] = useState([]);
  const [ sourceAccountConfig, setSourceAccountConfig] = useState(migrationDefaultObject.sourceAccountConfig)
  const [selectedCategoryCount, setselectedCategoryCount] = useState(0);
  const [dependentDataLookup, setDependentDataLookup] = useState({});


  useEffect(() => {
    if (currentMigID) {
      dispatch(GETMIGRATIONSTATUSLIST_REQ({ "migrationID": currentMigID }));
    }
    dispatch(GETMIGRATIONDEFAULTOBJECT_REQ());
  }, []);
  console.log("formik.values.isDataMigrationEnabled",formik.values)
  useEffect(() => {
    if (!isReadOnlyView) {
      setMigrationDefaultObject(migrationDefaultObject.data)
    }
    if(formik.values.isFromSourceAccount && migrationDefaultObject && migrationDefaultObject.data &&migrationDefaultObject.data.length > 0) {
      setMigrationDefaultObject(migrationDefaultObject.data)
      setselectedDataConfigFields(migrationDefaultObject.data)

    }
  }, [migrationDefaultObject]);

    useEffect(() => {
          if (currentMigID) {
              urlParams.current.id = currentMigID;
              dispatch(GETMIGRATIONDETAILS_REQ(urlParams.current));
          }
      }, [currentMigID]);

  useEffect(() => {
    if (isReadOnlyView) {
      let specialParent = ['GENERALSETTINGS', 'CONFIGURATIONSETTINGS'];

      for (let c = 0; c < migrationStatusResult.data.length; c++) {
        let index = migrationObjectArray.findIndex(object => object.module == migrationStatusResult.data[c].config_module)
        if (index != -1) {
          if (migrationObjectArray[index].child.length > 0) {
            let childIndex = migrationObjectArray[index].child.findIndex(object => object.module == migrationStatusResult.data[c].config_name)
            if (childIndex != -1) {
              migrationObjectArray[index].child[childIndex].checked = true
              const element = document.getElementById("comments_" + index)
              if (element) {
                document.getElementById("comments_" + index).indeterminate = true
              }
            }
          }
          let isAllChildChecked = migrationObjectArray[index].child.filter((obj) => obj.checked)
          if (isAllChildChecked.length == migrationObjectArray[index].child.length) {
            migrationObjectArray[index].checked = true
              const element = document.getElementById("comments_" + index)
              if (element) {
                document.getElementById("comments_" + index).indeterminate = false
              }
          }
        }
        else {
          for (let s = 0; s < specialParent.length; s++) {
            let index = migrationObjectArray.findIndex(object => object.module == specialParent[s])
            if (index != -1) {
              if (migrationObjectArray[index].child.length > 0) {
                let childIndex = migrationObjectArray[index].child.findIndex(object => object.module == migrationStatusResult.data[c].config_module)
                if (childIndex != -1) {
                  migrationObjectArray[index].child[childIndex].checked = true
                  const element = document.getElementById("comments_" + index)
                  if (element) {
                    document.getElementById("comments_" + index).indeterminate = true
                  }
                 
                }
              }
              let isAllChildChecked = migrationObjectArray[index].child.filter((obj) => obj.checked)
              if (isAllChildChecked.length == migrationObjectArray[index].child.length) {
                migrationObjectArray[index].checked = true
                  const element = document.getElementById("comments_" + index)
                  if (element) {
                    document.getElementById("comments_" + index).indeterminate = false
                  }
              }
            }
          }
        }
      }
      setMigrationDefaultObject([...migrationObjectArray])
    }
  }, [isReadOnlyView])

  useEffect(() => {
    if (formik.values.isDataMigrationEnabled && formik.values.isFromSourceAccount && migrationObjectArray && migrationObjectArray.length > 0) {
      setselectedCategoryCount(20)
      let specialParent = ['GENERALSETTINGS', 'CONFIGURATIONSETTINGS'];
      for (let c = 0; c < sourceAccountConfig.data.length; c++) {
        let index = migrationObjectArray.findIndex(object => object.module === sourceAccountConfig.data[c].config_module)
        if (index !== -1) {
          if (migrationObjectArray[index].child.length > 0) {
            let childIndex = migrationObjectArray[index].child.findIndex(object => object.module === sourceAccountConfig.data[c].config_name)
            if (childIndex !== -1) {
              migrationObjectArray[index].child[childIndex].checked = true
              migrationObjectArray[index].child[childIndex].dependency?.forEach((dependecy) => {
                if (dependecy.parentModule !== 'DEPENDENT_DATA') return; // skip non dependent data module
                let from = { parentModule: migrationObjectArray[index].module, childModule: migrationObjectArray[index].child[childIndex].module, parentName: migrationObjectArray[index].name, childName: migrationObjectArray[index].child[childIndex].name }
                updateChildMigrationDependecy(from, { ...dependecy, value: true })
              })
              const element = document.getElementById("comments_" + index)
              if (element) {
                document.getElementById("comments_" + index).indeterminate = true
              }

            }
          }
          let isAllChildChecked = migrationObjectArray[index].child.filter((obj) => obj.checked)
          if (isAllChildChecked.length === migrationObjectArray[index].child.length) {
            migrationObjectArray[index].checked = true
            const element = document.getElementById("comments_" + index)
            if (element) {
              document.getElementById("comments_" + index).indeterminate = false
            }
          }
        }
        else {
          for (let s = 0; s < specialParent.length; s++) {
            let index = migrationObjectArray.findIndex(object => object.module === specialParent[s])
            if (index !== -1) {
              if (migrationObjectArray[index].child.length > 0) {
                let childIndex = migrationObjectArray[index].child.findIndex(object => object.module === sourceAccountConfig.data[c].config_module)
                if (childIndex !== -1) {
                  migrationObjectArray[index].child[childIndex].checked = true
                  migrationObjectArray[index].child[childIndex].dependency?.forEach((dependecy) => {
                    if (dependecy.parentModule !== 'DEPENDENT_DATA') return; // skip non dependent data module
                    let from = { parentModule: migrationObjectArray[index].module, childModule: migrationObjectArray[index].child[childIndex].module, parentName: migrationObjectArray[index].name, childName: migrationObjectArray[index].child[childIndex].name }
                    updateChildMigrationDependecy(from, { ...dependecy, value: true })
                  })
                  const element = document.getElementById("comments_" + index)
                  if (element) {
                    document.getElementById("comments_" + index).indeterminate = true
                  }
                }
              }
              let isAllChildChecked = migrationObjectArray[index].child.filter((obj) => obj.checked)
              if (isAllChildChecked.length === migrationObjectArray[index].child.length) {
                migrationObjectArray[index].checked = true
                const element = document.getElementById("comments_" + index)
                if (element) {
                  document.getElementById("comments_" + index).indeterminate = false
                }
              }
            }
          }
        }
      }
      setMigrationDefaultObject([...migrationObjectArray])
    }
  }, [formik.values.isFromSourceAccount, selectedDataConfigFields])

  useEffect(() => {
    if (isValidationMaded) {
      if (validationResult?.data?.modules.length > 0) {
        let currentMigrationObjectArray = [...migrationObjectArray]
         for(let valIdx = 0 ; valIdx < validationResult.data.modules.length ; valIdx++ )   
            {
               for(let currentIdx = 0 ; currentIdx < currentMigrationObjectArray.length ; currentIdx++){ 
                 
                  if(currentMigrationObjectArray[currentIdx].module == validationResult.data.modules[valIdx].config_module )
                      {
                        currentMigrationObjectArray[currentIdx].isRequired = true;
                          if( currentMigrationObjectArray[currentIdx].child?.length > 0 )
                            {
                                  for(let childIdx = 0 ; childIdx < currentMigrationObjectArray[currentIdx].child.length ; childIdx++) 
                                  {
                                    if(currentMigrationObjectArray[currentIdx]?.child[childIdx]?.module == validationResult.data.modules[valIdx].config_name){
                                      currentMigrationObjectArray[currentIdx].child[childIdx].isRequired = true
                                       break;          
                                    }
                                  }
                            }
                            break;
                      }
               }
              }
              setMigrationDefaultObject([...currentMigrationObjectArray])

        setDependencyList(validationResult.data.modules)
        setOpenModal(true)
      }
      else {
        dispatch(GETMIGRATIONSTART_REQ(formik['values']));
      }
    }
  }, [validationResult]);

  useEffect(() => {
    if (migrationStartResult.data && Object.keys(migrationStartResult).length > 0) {
      setselectedConfigFields(formik?.values?.migration_config?.config_migrations ? formik['values']['migration_config']['config_migrations'] : [])
      setStep("configStatus")
      setCurrentMigID(migrationStartResult.data.migrationUID)
      dispatch(actions.RESET_STATE("migration.migration_start_result"));
      dispatch(actions.RESET_STATE("migration.migration_status_list"))
    }
  }, [migrationStartResult]);

  const setParentCurrentTab = (e, index, skip) => {
    if ('comments_' + index === e.target['id'] && !skip) {
      let result = updateParentMigrationObject(index)
      setMigrationDefaultObject([...result])
      return false
    }

    let currentTab = currentTabIndex.indexOf(index)
    if (currentTab > -1) {
      currentTabIndex.splice(currentTab, 1)
      setcurrentTabIndex([...currentTabIndex])
    } else {
      setcurrentTabIndex([...currentTabIndex, index])
    }
  }

  const setChildCurrentTab = (parentIndex, childIndex) => {
    let result = updateChildMigrationObject(parentIndex, childIndex)
    setMigrationDefaultObject([...result])
  }

  const updateParentMigrationObject = (index) => {
    let parent = migrationObjectArray[index]
    let isChecked = !migrationObjectArray[index]?.checked
    setselectedCategoryCount((prev) => isChecked ? prev + 1 : prev - 1) // for "start migration" button
    migrationObjectArray[index].checked = isChecked
    if (migrationObjectArray[index]?.child.length > 0) {
      migrationObjectArray[index].child = migrationObjectArray[index]?.child.map((object) => {
        console.log("object inside parent ", object)
        let result = sourceAccountConfig.data.find((obj) => {
          if (formik.values.isFromSourceAccount && formik.values.isDataMigrationEnabled && obj.config_module === migrationObjectArray[index].module && obj.config_name === object.module) {
            return true;
          }
          return false;
        })
        if (result) {
          object.checked = true
        }
        else {
          object.checked = isChecked
        }
        let from = { parentModule: parent.module, childModule: object.module, parentName: parent.name, childName: object.name }
        object.dependency?.forEach((dependecy) => {
          if (dependecy.parentModule !== 'DEPENDENT_DATA') return; // skip non dependent data module
          updateChildMigrationDependecy(from, { ...dependecy, value: object.checked })
        })
        return object;
      })
    }

    let isAllChildChecked = parent.child.every((obj) => obj.checked)
    parent.checked = isAllChildChecked
    parent.isHaveInterminate = !isAllChildChecked && parent.child.some((obj) => obj.checked);
    let checkboxEle = document.getElementById("comments_" + index)
    if (checkboxEle) checkboxEle.indeterminate = parent.isHaveInterminate

    return migrationObjectArray;
  }

  const updateChildMigrationDependecy = (from, { parentModule, module, value }) => {

    let parent = migrationObjectArray.find((obj) => obj.module === parentModule);
    let child = parent.child.find((obj) => obj.module === module);
    let wasChecked = child.checked;

    parent.isHaveInterminate = true

    if (value) {
      child.checked = true;
      setDependentDataLookup((lookupData) => {
        if (!lookupData[parentModule]) lookupData[parentModule] = {};
        if (!lookupData[parentModule][module]) lookupData[parentModule][module] = [];
        if (lookupData[parentModule][module].findIndex(item => item.parentModule === from.parentModule && item.childModule === from.childModule) !== -1) return lookupData; // already exist
        lookupData[parentModule][module].push(from);
        return { ...lookupData };
      })
    } else {
      if (!dependentDataLookup[parentModule]?.[module]) return dependentDataLookup;
      dependentDataLookup[parentModule][module] = dependentDataLookup[parentModule]?.[module]?.filter((item) => {
        return item.parentModule !== from.parentModule || item.childModule !== from.childModule
      });
      child.checked = dependentDataLookup[parentModule][module]?.length > 0;
      setDependentDataLookup({ ...dependentDataLookup });
    }
    // only adjust the global count when this dependency registration/removal actually flips Team/User/Products' own checked state
    if (wasChecked !== child.checked) {
      setselectedCategoryCount((prev) => child.checked ? prev + 1 : prev - 1) // for "start migration" button
    }
    child.isRequired = false;

    let isAllChildChecked = parent.child.every((obj) => obj.checked)
    parent.checked = isAllChildChecked
    parent.isHaveInterminate = !isAllChildChecked && parent.child.some((obj) => obj.checked);
    let checkboxEle = document.getElementById("comments_" + parentModule)
    if (checkboxEle) checkboxEle.indeterminate = parent.isHaveInterminate
    // migrationObjectArray[parentIndex] = parent;

    return migrationObjectArray;
  }

  const updateChildMigrationObject = (parentIndex, childIndex) => {

    let parent = migrationObjectArray[parentIndex]
    let isChecked = !parent?.child[childIndex]?.checked

    sourceAccountConfig.data.forEach((obj) => {
      if (formik.values.isFromSourceAccount && formik.values.isDataMigrationEnabled && obj.config_module === parent.module && obj.config_name === parent.child[childIndex].module) {
        isChecked = true
        toast.error("Data migration is enabled, so this field is required")
      }
    })
    parent.isHaveInterminate = true
    setselectedCategoryCount((prev) => isChecked ? prev + 1 : prev - 1) // for "start migration" button

    parent.child[childIndex].checked = isChecked;
    parent.child[childIndex].isRequired = false;
    let isAllChildChecked = parent.child.filter((obj) => obj.checked)
    if (isAllChildChecked.length === parent.child.length) {
      parent.checked = true
      parent.isHaveInterminate = false
    } else {
      parent.checked = false
      parent.isHaveInterminate = isAllChildChecked.length === 0 ? false : true
    }

    document.getElementById("comments_" + parentIndex).indeterminate = parent.isHaveInterminate


    parent.child[childIndex].dependency?.forEach((dependecy) => {
      if (dependecy.parentModule !== 'DEPENDENT_DATA') return; // skip non dependent data module
      let from = { parentName: parent.name, parentModule: parent.module, childModule: parent.child[childIndex].module, childName: parent.child[childIndex].name }
      updateChildMigrationDependecy(from, { ...dependecy, value: isChecked })
    })
    migrationObjectArray[parentIndex] = parent;
    return migrationObjectArray;
  }

  const toggleDependentDataChild = (parentModule, childModule) => {
    let parentIndex = migrationObjectArray.findIndex((obj) => obj.module === parentModule)
    if (parentIndex === -1) return migrationObjectArray

    let parent = migrationObjectArray[parentIndex]
    let childIndex = parent.child.findIndex((obj) => obj.module === childModule)
    if (childIndex === -1) return migrationObjectArray

    let isChecked = !parent.child[childIndex].checked
    parent.child[childIndex].checked = isChecked
    parent.child[childIndex].isRequired = false
    setselectedCategoryCount((prev) => isChecked ? prev + 1 : prev - 1) // for "start migration" button

    let isAllChildChecked = parent.child.every((obj) => obj.checked)
    parent.checked = isAllChildChecked
    parent.isHaveInterminate = !isAllChildChecked && parent.child.some((obj) => obj.checked)
    let checkboxEle = document.getElementById("comments_" + parentModule)
    if (checkboxEle) checkboxEle.indeterminate = parent.isHaveInterminate

    migrationObjectArray[parentIndex] = parent
    return migrationObjectArray
  }

  const validation = () => {

    let finalObject = []
    let ignoreParent = ['GENERALSETTINGS', 'CONFIGURATIONSETTINGS'];

    migrationObjectArray.forEach((config) => {
      if (!config.child || config.child.length <= 0) {
        if (config.checked) {
          finalObject.push({
            config_name: config.module
          })
        }
      } else {
        config.child.forEach((childConfig) => {
          if (childConfig.checked) {
            let temp
            if (ignoreParent.indexOf(config.module) > -1) {
              temp = { config_module: childConfig.module }
            } else {
              temp = {
                config_module: config.module,
                config_name: childConfig.module
              }
            }
            finalObject.push(temp)
          }
        })
      }
    })

    formik['values']['migration_config'] = {
      "config_migrations": finalObject
    };

    dispatch(GETMIGRATIONOBJECTVALIDATE_REQ(formik.values));
    setisValidationMaded(true)
  }
  return (
    <section aria-labelledby="primary-heading" className="flex h-full min-w-0 flex-1 flex-col lg:order-last">
      <div className="h-full">
        <div className="relative h-full w-full overflow-hidden bg-white rounded-lg shadow px-4">
          <div className="p-2">
            <div className="flow-root">
              <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div className="inline-block min-w-full py-4 align-middle sm:px-6 lg:px-8">
                  <div className="mx-auto pb-3 border-b sm:flex sm:items-center sm:justify-between">
                    <h3 className="text-lg font-semibold leading-6 text-gray-900">
                      Module Selection
                    </h3>
                    <div className="mt-3 sm:ml-4 sm:mt-0">
                      <div className="flex space-x-2">
                        {!isReadOnlyView && <button disabled={(!(selectedCategoryCount > 0))} type="button" onClick={() => validation()}
                          className="relative inline-flex items-center gap-x-1.5 rounded-md bg-gray-800 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:opacity-50">
                          Start Migration
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                            strokeWidth="1.5" stroke="currentColor" className="w-4 h-4">
                            <path strokeLinecap="round" strokeLinejoin="round"
                              d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
                          </svg>
                        </button>}
                      </div>
                    </div>
                  </div>

                  <div className="mt-4 mb-4 gap-x-6 gap-y-6">
                    <ul>
                      {migrationObjectArray?.filter((obj) => !['DEPENDENT_DATA', 'DATA_MIGRATION'].includes(obj?.module))?.map((parentObject, index) => (
                        <div id="accordion-open" data-accordion="open">
                          <h2 id="accordion-open-heading-1">
                            <button type="button" onClick={(e) => setParentCurrentTab(e, index)}
                              className={`${currentTabIndex.indexOf(index) > -1 ? "bg-gray-100" : ""} flex items-center justify-between w-full p-5 font-medium rtl:text-right text-gray-500 border border-b-0 border-gray-200 rounded-t-xl focus:ring-4 focus:ring-gray-200 gap-3`}
                              aria-expanded="true"
                            >
                              <span className="flex items-center text-lg">
                                <input id={"comments_" + index}
                                  aria-describedby="comments-description" name="comments" disabled={isReadOnlyView} type="checkbox" checked={parentObject.checked}  //|| (formik.values.isFromSourceAccount && formik.values.isDataMigrationEnabled)
                                  className={`border-gray-300 h-4 w-4 rounded  text-gray-800 focus:ring-gray-800 mr-3 indeterminate:border-primary ${parentObject.isRequired ? "indeterminate:bg-red-400" : "indeterminate:bg-primary"} indeterminate:after:absolute indeterminate:after:ms-[0.2rem] indeterminate:after:mt-[6px] indeterminate:after:w-[0.5rem] indeterminate:after:border-[0.05rem] indeterminate:after:border-solid indeterminate:after:border-white indeterminate:focus:after:w-[0.5rem] indeterminate:focus:after:rounded-none indeterminate:focus:after:border-[0.125rem] indeterminate:focus:after:border-b-0 indeterminate:focus:after:border-e-0 indeterminate:focus:after:border-s-0 dark:indeterminate:border-primary dark:indeterminate:bg-primary indeterminate:!bg-none`}

                                />
                                <label className={`${parentObject.isRequired === true ? "font-medium text-red-400" : "font-medium text-gray-500"}`}> {parentObject.name}</label></span>
                              <svg data-accordion-icon className={currentTabIndex.indexOf(index) > -1 ? "w-3 h-3 rotate-180 shrink-0" : "w-3 h-3 shrink-0"} aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"
                                  strokeWidth="2" d="M9 5 5 1 1 5" />
                              </svg>
                            </button>
                          </h2>
                          <div className={currentTabIndex.indexOf(index) > -1 ? 'open' : 'hidden'} aria-labelledby="accordion-open-heading-1">
                            <div className="px-4 py-5 border border-b-0 border-gray-200">
                              <ul className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
                                {parentObject.child.map((childObject, childIndex) => (
                                  (<li className="col-span-1 divide-y divide-gray-200 rounded-lg">
                                    <div className="flex w-full items-center px-6 py-3">
                                      <div className="flex h-6 items-center mr-3">
                                        <input id="child_comments" aria-describedby="child_comments-description" name="child_comments"
                                          type="checkbox" disabled={isReadOnlyView} checked={childObject.checked} onClick={() => setChildCurrentTab(index, childIndex)}   //||  (formik.values.isFromSourceAccount && formik.values.isDataMigrationEnabled)
                                          className={`${childObject.isRequired === true ? "h-4 w-4 rounded border-red-500 text-gray-800 focus:ring-gray-800" : "h-4 w-4 rounded border-gray-300 text-gray-800 focus:ring-gray-800"}`} />
                                      </div>
                                      <div className="ml-1 text-sm leading-6">
                                        <label className={`${childObject.isRequired === true ? "font-medium text-red-500" : "font-medium text-gray-900"}`}>{childObject.name}</label>
                                      </div>
                                    </div>
                                  </li>)
                                ))
                                }
                              </ul>
                            </div>
                          </div>
                        </div>
                      ))
                      }
                      {
                        migrationObjectArray?.filter((obj) => {
                          let migration = isReadOnlyView ? migrationDetails?.data[0]?.isDataMigrationEnabled : formik.values.isDataMigrationEnabled
                          return (migration && ['DATA_MIGRATION'].includes(obj.module)) || (!migration && ['DEPENDENT_DATA'].includes(obj.module))
                        })?.map((parentObject) => (
                          <div id="accordion-open" data-accordion="open">
                            <h2 id="accordion-open-heading-1">
                              <button type="button" onClick={(e) => setParentCurrentTab(e, parentObject.module, true)}
                                className={`${currentTabIndex.indexOf(parentObject.module) > -1 ? "bg-gray-100" : ""} flex items-center justify-between w-full p-5 font-medium rtl:text-right text-gray-500 border border-b-0 border-gray-200 rounded-t-xl focus:ring-4 focus:ring-gray-200 gap-3`}
                                aria-expanded="true"
                              >
                                <span className="flex items-center text-lg">
                                  <input id={"comments_" + parentObject.module}
                                    onClick={(event) => {
                                      console.log("stop propagation called")
                                      // event.stopPropagation();
                                      event.preventDefault();
                                    }}
                                    aria-describedby="comments-description" name="comments" disabled={isReadOnlyView} type="checkbox" checked={parentObject.checked}  //|| (formik.values.isFromSourceAccount && formik.values.isDataMigrationEnabled)
                                    className={`border-gray-300 h-4 w-4 rounded  text-gray-800 focus:ring-gray-800 mr-3 indeterminate:border-primary ${parentObject.isRequired ? "indeterminate:bg-red-400" : "indeterminate:bg-primary"} indeterminate:after:absolute indeterminate:after:ms-[0.2rem] indeterminate:after:mt-[6px] indeterminate:after:w-[0.5rem] indeterminate:after:border-[0.05rem] indeterminate:after:border-solid indeterminate:after:border-white indeterminate:focus:after:w-[0.5rem] indeterminate:focus:after:rounded-none indeterminate:focus:after:border-[0.125rem] indeterminate:focus:after:border-b-0 indeterminate:focus:after:border-e-0 indeterminate:focus:after:border-s-0 dark:indeterminate:border-primary dark:indeterminate:bg-primary indeterminate:!bg-none`}

                                  />
                                  <label className={`${parentObject.isRequired === true ? "font-medium text-red-400" : "font-medium text-gray-500"}`}> {parentObject.name}</label></span>
                                <svg data-accordion-icon className={currentTabIndex.indexOf(parentObject.module) > -1 ? "w-3 h-3 rotate-180 shrink-0" : "w-3 h-3 shrink-0"} aria-hidden="true"
                                  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                                  <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"
                                    strokeWidth="2" d="M9 5 5 1 1 5" />
                                </svg>
                              </button>
                            </h2>
                            <div className={currentTabIndex.indexOf(parentObject.module) > -1 ? 'open' : 'hidden'} aria-labelledby="accordion-open-heading-1">
                              <div className="px-4 py-5 border border-b-0 border-gray-200">
                                <ul className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
                                  {parentObject.child.map((childObject) => (
                                    (<li key={childObject.module} className="col-span-1 divide-y divide-gray-200 rounded-lg">
                                      <div className="flex w-full items-center px-6 py-3">
                                        <div className="flex h-6 items-center mr-3">
                                          <input id={"child_comments_" + parentObject.module + "_" + childObject.module} aria-describedby="child_comments-description" name="child_comments"
                                            type="checkbox" disabled={isReadOnlyView} checked={childObject.checked}
                                            onChange={(event) => {
                                              if (parentObject.module === 'DATA_MIGRATION') {
                                                toast.error("Data migration is enabled, so this field is required")
                                                setMigrationDefaultObject([...migrationObjectArray]); // snap the checkbox back to its required state
                                                return;
                                              }

                                              let wasChecked = childObject.checked;
                                              let modules = dependentDataLookup[parentObject.module]?.[childObject.module] || [];

                                              let result = toggleDependentDataChild(parentObject.module, childObject.module)
                                              setMigrationDefaultObject([...result])

                                              if (wasChecked && modules.length > 0) {
                                                let moduleNames = modules.reduce((names, mod) => {
                                                  if (!names[mod.parentName]) names[mod.parentName] = [];
                                                  names[mod.parentName].push(mod.childName);
                                                  return names;
                                                }, {})
                                                toast.warning(() => (
                                                  <>
                                                    <div>{`Following configurations depend on this data. Migration may fail for them if you deselect it:`}</div>
                                                    <ul className="list-disc ml-5 pl-2">
                                                      {Object.keys(moduleNames).map((parentName) => {
                                                        return (
                                                          <li key={parentName}>
                                                            <span className="font-bold">{parentName}:</span> {moduleNames[parentName].join(', ')}
                                                          </li>
                                                        )
                                                      })
                                                      }
                                                    </ul>
                                                  </>
                                                ))
                                              }
                                            }}   //||  (formik.values.isFromSourceAccount && formik.values.isDataMigrationEnabled)
                                            className={`${childObject.isRequired === true ? "h-4 w-4 rounded border-red-500 text-gray-800 focus:ring-gray-800" : "h-4 w-4 rounded border-gray-300 text-gray-800 focus:ring-gray-800"}`} />
                                        </div>
                                        <div className="ml-1 text-sm leading-6">
                                          <label className={`${childObject.isRequired === true ? "font-medium text-red-500" : "font-medium text-gray-900"}`}>{childObject.name}</label>
                                        </div>
                                      </div>
                                    </li>)
                                  ))
                                  }
                                </ul>
                              </div>
                            </div>
                          </div>
                        ))
                      }
                    </ul>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Popup
        modalState={[openModal, setOpenModal]}
        size="2xl"
        alignActions="end"
        cancelText="Proceed anyway"
        cancelClass="text-red-700 ring-red-200 hover:bg-red-50 hover:text-red-700"
        confirmText="Go back and select"
        onCancel={() => {
          dispatch(GETMIGRATIONSTART_REQ(formik['values']));
        }}
        onConfirm={() => {
          setOpenModal(false);
        }}
        fullHeader={
          <div className="flex w-full items-start gap-4 text-left">
            <div className="flex h-10 w-10 flex-none items-center justify-center rounded-xl bg-amber-100 text-amber-700">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z" />
                <path d="M12 9v4" />
                <path d="M12 17h.01" />
              </svg>
            </div>
            <div className="flex flex-1 flex-col gap-1">
              <h2 className="text-lg font-semibold tracking-tight text-gray-900">
                Dependency List
              </h2>
              <p className="text-sm leading-relaxed text-amber-700">
                {`The modules below depend on configurations you haven't selected. If you proceed without selecting them, migration may fail for these dependent modules. Are you sure you want to proceed?`}
              </p>
            </div>
          </div>
        }
        content={
          <div className="text-left pb-6">
            <div className="grid grid-cols-[minmax(0,1fr)_minmax(0,1.4fr)] gap-4 px-4 pb-1 text-[11px] font-semibold uppercase tracking-wider text-gray-500">
              <span>Missing</span>
              <span>Needed by</span>
            </div>
            <div className="max-h-80 overflow-y-auto rounded-xl border border-gray-200">
              {groupDependencyList(dependencyList).map((item, index) => (
                <div
                  key={index}
                  className={`grid grid-cols-[minmax(0,1fr)_minmax(0,1.4fr)] gap-4 px-4 py-3.5 ${index !== 0 ? "border-t border-gray-100" : ""}`}
                >
                  <div className="flex min-w-0 flex-col gap-0.5">
                    <span className="text-sm font-semibold text-gray-900">{item.name}</span>
                    <span className="text-xs text-gray-500">{item.category}</span>
                  </div>
                  <div className="flex min-w-0 flex-col gap-1">
                    {item.neededBy.map((n, idx) => (
                      <span key={idx} className="text-[13px] leading-5 text-gray-900">
                        <span className="text-gray-500">{n.parent} &rsaquo; </span>{n.child}
                      </span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        }
      />
    </section>
  )
}